import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=1795143a&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"
import style0 from "./Department.vue?vue&type=style&index=0&id=1795143a&prod&lang=scss&scoped=true"
import style1 from "./Department.vue?vue&type=style&index=1&id=1795143a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795143a",
  null
  
)

export default component.exports